export const BillingMode = {
  MONTHLY: 1,
  YEARLY: 2
};
